import {useContext} from 'react'
import Image from 'next/image'
import Avatar from '@/components/Avatar'
import HeaderAccountMenu from '@/components/Header/Account/HeaderAccountMenu'
import styles from '@/components/Header/Header.module.scss'
import {AuthContext} from '@/context/AuthProvider'
import Dropdown from 'antd/lib/dropdown/dropdown'
import {ONGformat} from '@utils/helpers'

type HeaderAccountDropdownProps = {
  user: OnliveUser
  hasDarkMode?: boolean
}

const HeaderAccountDropdown = ({
  user,
  hasDarkMode,
}: HeaderAccountDropdownProps) => {
  const {accountBalance} = useContext(AuthContext)

  return (
    <Dropdown
      dropdownRender={() => (
        <HeaderAccountMenu user={user} hasDarkMode={hasDarkMode} />
      )}
      trigger={['click']}
      arrow
      placement="bottomRight"
      destroyPopupOnHide
    >
      <div className={styles.user}>
        <div className={styles.userAvatar}>
          <Avatar bjId={user?.uid} alt={user?.uid} width={30} height={30} />
        </div>
        <div className={styles.userInfo}>
          <div className={styles.userId}>{user?.unick}</div>
          <div className={styles.userONG}>
            <span>{ONGformat(accountBalance)}</span>
            <Image
              src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/ong.svg'}
              width={15}
              height={15}
              alt="ong"
            />
          </div>
        </div>
        <Image
          src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/header/arrow-down.svg'}
          className={styles.userCarret}
          width={10}
          height={10}
          alt=""
        />
      </div>
    </Dropdown>
  )
}

export default HeaderAccountDropdown
